exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.catelog-main .category-card-item {\n\theight: calc(100vh - 382px);\n    overflow: auto;\n}\n.sidebar-enable, .sidebar-disable {\n\tmin-height: auto !important;\n}\n.catelog-main .menu-body {\n\theight: auto !important\n}\n.catelog-main .category-card {\n\theight: calc(100vh - 353px);\n\toverflow: auto;\n}\n", ""]);

// exports
